import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { UseStore } from 'zustand';
import { organizationData } from '../../core';
import { Auto, MultiSelect } from '../../core/controls';
import { formApi } from '../../core/form';
import { HBox, VBox } from '../../core/layout';
import {
  DepartmentRole,
  LocationRole,
  OrganizationApi,
  OrganizationRole,
  OrganizationSelection,
} from '../../core/organization-api';

interface OrganizationSelectProps {
  direction?: 'horizontal' | 'vertical';
  organizationOnly?: boolean;
  containerWidth?: string;
  controlWidth?: string;
  api: UseStore<OrganizationApi>;
  onComplete?: () => void;
  partial?: boolean,
  variant?: string
}

export function OrganizationSelect(props?: OrganizationSelectProps) {
  const { api, organizationOnly, controlWidth, containerWidth, direction, partial, variant } =
    props;

  const organizations = api((s) => s.organizations);
  const selection = api((s) => s.selection);
  const setSelection = api((s) => s.setSelection);

  selection && organizationData.setState({departments: selection?.location?.departments});
  selection && organizationData.setState({locations: selection?.organization?.locations});

  const [locations, setLocations] = useState<LocationRole[]>([]);
  const [departments, setDepartments] = useState<DepartmentRole[]>([]);

  function setOrganization(organization: OrganizationRole) {
    update({ organization, location: null, department: null });

    if (organization && organization.locations) {
      setLocations(organization.locations);
      if (organization.locations.length === 1) {
        const location = organization.locations[0];
        loc.value.getState().setValue(location);
        setDepartments(location.departments);
        const department =
          location.departments?.length === 1 ? location.departments[0] : null;

        update({
          organization,
          location: organization.locations[0],
          department,
        });
      }
    } else {
      setLocations([]);
      setDepartments([]);
    }
  }

  function setLocation(loc: LocationRole) {
    if (!selection?.organization) {
      return;
    }
    if (loc && loc.departments) {
      update({ ...selection, ...{ location: loc } });
      setDepartments(loc.departments);

      if (loc.departments.length === 1) {
        dep.value.getState().setValue(loc.departments[0]);
        update({ location: loc, department: loc.departments[0] });
      }
    }
  }

  const form = formApi({
    values: {
      org: selection?.organization,
      loc: selection?.location,
      dep: selection?.department,
    },
    fields: {
      org: {
        label: '',
        placeholder: 'Organization',
        id: 'organization',
        searchWidth: 300,
        searchHeight: '80vh',
        list: organizations,
        listLabel: (v) => v.name,
        onChange: (v) => setOrganization(v),
      },
      loc: {
        label: '',
        placeholder: 'Location',
        id: 'location',
        searchWidth: 300,
        list: locations,
        listLabel: (v) => v.name,
        onChange: (v) => setLocation(v),
      },
      dep: {
        label: '',
        placeholder: 'Department',
        id: 'department',
        list: departments,
        listLabel: (v) => v.code,
        onChange: (dep) => {
          if (!selection.location) {
            return;
          }
          if (dep) {
            update({ department: dep });
          }
        },
      },
    },
  });

  const { org, loc, dep } = form.controls;

  function updateControls(a: OrganizationSelection) {
    if (a) {
      const { organization, location, department } = a;
      if (organization) {
        setOrganization(organization);

        if (location) {
          setLocation(location);
          loc.setListValue(location);
        }

        if (department) {
          dep.setListValue(department);
        }
      }
    }
  }

  api.getState().setUpdateFn(updateControls);

  useEffect(() => {
    updateControls(selection);
  }, []);

  function update(patch: any) {
    const obj: OrganizationSelection = { ...selection, ...patch };

    setSelection(obj);

    form.values.setState({
      value: {
        org: obj.organization,
        loc: obj.location,
        dep: obj.department,
      },
    });
  }

  partial && (loc.variant = variant as any);
  partial && (dep.variant = variant as any);

  let components = [];
  if (organizationOnly) {
    return <Auto {...org} key="org" />;
  } else {
    if(partial){
      components = [
        <form>
          <Grid item container direction='row'
            spacing={2}
            style={{ flexWrap: 'nowrap', width: '90%', paddingBottom: 6, paddingTop: 6 }}
            alignItems='flex-start'>
            <Grid item xs={6} style={{}}>
            <div style={{color: 'gray', paddingBottom: 8, paddingLeft: 5}}>Location:</div>
                  <MultiSelect {...loc} key='loc' />
            </Grid>
            <Grid item xs={6} style={{}}>
                 <div style={{color: 'gray', paddingBottom: 5, paddingLeft: 5}}>Department:</div>
                 <Auto {...dep} key='dep' />
            </Grid>
         </Grid>
        </form>
        
        
    ]
    }else{
      components = !partial ? [ <Auto {...org} key="org" />] : [];
      components.push(<Auto {...loc} key="loc"/>);
      components.push(<Auto {...dep} key="dep"/>);
    }
    

    const constainerStyle = { root: { width: containerWidth || '100%' } };
    const itemStyle = { root: { width: controlWidth || '200px' } };

    return (
      <>
        {direction === 'horizontal' ? (
          <HBox containerStyle={constainerStyle} itemStyle={itemStyle}>
            {components}
          </HBox>
        ) : (
          <VBox containerStyle={constainerStyle} itemStyle={itemStyle}>
            {components}
          </VBox>
        )}
      </>
    );
  }
}

export function OrganizationSelectAudit(props?: OrganizationSelectProps) {
  const { api, organizationOnly, controlWidth, containerWidth, direction, partial, variant } =
    props;
  
  const organizations = api((s) => s.organizations);
  const selection = api((s) => s.selection);
  const setSelection = api((s) => s.setSelection);
  
  
  console.info('OrganizationSelectAudit', selection);
  const [locations, setLocations] = useState<LocationRole[]>([]);
  const [departments, setDepartments] = useState<DepartmentRole[]>([]);


  function setOrganization(organization: OrganizationRole) {
    update({ organization, location: null, department: null });

    if (organization && organization.locations) {
      setLocations(organization.locations);
      if (organization.locations.length === 1) {
        const location = organization.locations[0];
        loc.value.getState().setValue(location);
        setDepartments(location.departments);
        const department =
          location.departments?.length === 1 ? location.departments[0] : null;

        update({
          organization,
          location: organization.locations[0],
          department,
        });
      }
    } else {
      setLocations([]);
      setDepartments([]);
    }
  }

  function setLocation(loc: LocationRole) {
    if (!selection?.organization) {
      return;
    }
    if (loc && loc.departments) {
      update({ ...selection, ...{ location: loc } });
      setDepartments(loc.departments);

      if (loc.departments.length === 1) {
        dep.value.getState().setValue(loc.departments[0]);
        update({ location: loc, department: loc.departments[0] });
      }
    }
  }

  const form = formApi({
    values: {
      org: selection?.organization,
      loc: selection?.location,
      dep: selection?.department,
    },
    fields: {
      org: {
        label: '',
        placeholder: 'Organization',
        id: 'organization',
        searchWidth: 300,
        searchHeight: '80vh',
        list: organizations,
        listLabel: (v) => v.name,
        onChange: (v) => setOrganization(v),
      },
      loc: {
        label: '',
        placeholder: 'Location',
        id: 'location',
        list: locations,
        listLabel: (v) => v.name,
        onChange: (v) => {
          //setLocation(v);
          if(v){
            update({ location: v });
          }
        },
      },
      dep: {
        label: '',
        placeholder: 'Department',
        id: 'department',
        list: departments,
        listLabel: (v) => v.code,
        onChange: (dep) => {
          if (!selection.location) {
            return;
          }
          if (dep) {
            update({ department: dep });
          }
        },
      },
    },
  });

  const { org, loc, dep } = form.controls;

  function updateControls(a: OrganizationSelection) {
    if (a) {
      const { organization, location, department } = a;
      if (organization) {
        setOrganization(organization);

        if (location) {
          setLocation(location);
          loc.setListValue(location);
        }

        if (department) {
          dep.setListValue(department);
        }
      }
    }
  }

 

  api.getState().setUpdateFn(updateControls);

 

  useEffect(() => {
    updateControls(selection);
  }, []);


  function update(patch: any) {
    const obj: OrganizationSelection = { ...selection, ...patch };

    setSelection(obj);

    form.values.setState({
      value: {
        org: obj.organization,
        loc: obj.location,
        dep: obj.department,
      },
    });
    
  }

  partial && (loc.variant = variant as any);
  partial && (dep.variant = variant as any);

  let components = [];
  if (organizationOnly) {
    return <Auto {...org} key="org" />;
  } else {
    if(partial){
      components = [
        <Grid container direction='row'
            style={{ flexWrap: 'nowrap',  paddingBottom: 6, paddingTop: 6, minWidth: 550 }}
            alignItems='flex-start'>
            <Grid item xs={12} style={{flex: 1}}>
            <div style={{color: 'gray', paddingBottom: 5, paddingLeft: 5}}>Location:</div>
                  <Auto {...loc} key='loc' />
            </Grid>
            <Grid item xs={12} style={{flex: 1, paddingLeft: 15}}>
                 <div style={{color: 'gray', paddingBottom: 5, paddingLeft: 5}}>Department:</div>
                 <Auto {...dep} key='dep' />
            </Grid>
         </Grid>
        
    ]
    }else{
      components = !partial ? [ <Auto {...org} key="org" />] : [];
      components.push(<Auto {...loc} key="loc"/>);
      components.push(<Auto {...dep} key="dep"/>);
    }
    

    const constainerStyle = { root: { width: containerWidth || '100%' } };
    const itemStyle = { root: { width: controlWidth || '200px' } };

    return (
      <>
        {direction === 'horizontal' ? (
          <HBox containerStyle={constainerStyle} itemStyle={itemStyle}>
            {components}
          </HBox>
        ) : (
          <VBox containerStyle={constainerStyle} itemStyle={itemStyle}>
            {components}
          </VBox>
        )}
      </>
    );
  }
}


export function OrgSelectDialog({ api, onComplete }: OrganizationSelectProps) {
  const open = api((s) => s.promptOrg);


  const onCancel = () => {
    api.setState({ promptOrg: false });
  };
  const onGo = () => {
    if (onComplete) {
      onComplete();
    }
    api.setState({ promptOrg: false });
  };

  return (
    open && (
      <Dialog open={open}>
        <DialogTitle>Choose a Location</DialogTitle>
        <DialogContent style={{ width: 450 }}>
          <OrganizationSelect
            api={api}
            direction="vertical"
            controlWidth="100%"
          />
          <br />
          <br />
        </DialogContent>

        <DialogActions>
          <Button onClick={onCancel} variant="outlined" color="primary">
            Cancel
          </Button>
          <Button onClick={onGo} variant="contained" color="primary">
            Go
          </Button>
        </DialogActions>
      </Dialog>
    )
  );
}
